import { containerStatusLabel } from './container-status-presentation.mjs?v=20260806.100';
import { OCEAN_STATUS_TOKENS } from './ocean-status-order.mjs?v=20260806.100';
import { workspaceChoiceMarkup } from './workspace-choice-control.mjs?v=20260806.100';

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

function dateTimeValue(value) {
  if (!Number.isSafeInteger(value) || value < 0) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}

function dateValue(value) {
  return dateTimeValue(value).slice(0, 10);
}

const PAYMENT_OPTIONS = Object.freeze([
  { value: 'paid', label: 'Paid', tone: 'paid' },
  { value: 'unpaid', label: 'Unpaid', tone: 'unpaid' },
]);

// The colour each status is drawn in. Separate from the label because these are
// this control's own class names, not the table's tone vocabulary.
const OCEAN_STATUS_TONES = Object.freeze({
  available_for_pickup: 'available',
  delivered_to_warehouse: 'delivered',
  transfer: 'delivered',
  pending: 'pending',
  empty_returned: 'empty-returned',
  cancelled: 'cancelled',
});

// The canonical statuses, in Alan's order and in his words (2026-08-09; 查验放行
// added 2026-08-12). Built from the same list the table sorts by and the same
// labels the table prints, so the intake form cannot drift from the column it
// writes to - it previously offered fourteen, eleven of them in English and four
// of them retired.
const OCEAN_STATUS_OPTIONS = Object.freeze(OCEAN_STATUS_TOKENS.map((value) => Object.freeze({
  value,
  label: containerStatusLabel(value, 'zh-CN'),
  tone: OCEAN_STATUS_TONES[value] || 'neutral',
})));

// A Container still carrying a retired value opens the form with nothing chosen
// rather than refusing to open it. The choice control rejects a value it was not
// given as an option, and the point of narrowing the list is that the next save
// lands on one of the nine.
function offeredOceanStatus(value) {
  const token = String(value ?? '').trim();
  return OCEAN_STATUS_TOKENS.includes(token) ? token : '';
}

export function workspaceStandardActionFields(actionType, existing = {}) {
  if (actionType === 'clerk_port_intake') {
    return `<label class="workspace-date-field"><span>ETA</span><input name="eta_at" type="date" value="${escapeHtml(dateValue(existing.eta_at))}" required><small data-field-error></small></label>
      ${workspaceChoiceMarkup({
        name: 'ocean_status',
        label: 'Ocean Status',
        value: offeredOceanStatus(existing.ocean_status),
        options: OCEAN_STATUS_OPTIONS,
      })}`;
  }
  if (actionType === 'clerk_lfd') {
    return `<label class="workspace-date-field"><span>LFD</span><input name="lfd_at" type="date" value="${escapeHtml(dateValue(existing.lfd_at))}" required><small data-field-error></small></label>
      <label class="workspace-date-field"><span>Pickup Appointment</span><input name="pickup_appointment_at" type="datetime-local" value="${escapeHtml(dateTimeValue(existing.pickup_appointment_at))}" required><small data-field-error></small></label>
      <label class="workspace-date-field"><span>Return Empty LFD</span><input name="return_empty_lfd_at" type="date" value="${escapeHtml(dateValue(existing.return_empty_lfd_at))}" required><small data-field-error></small></label>`;
  }
  if (actionType === 'finance_initial') {
    return `${workspaceChoiceMarkup({
      name: 'ctf_status',
      label: 'CTF Status',
      value: existing.ctf_status || '',
      options: PAYMENT_OPTIONS,
    })}${workspaceChoiceMarkup({
      name: 'tmf_status',
      label: 'TMF Status',
      value: existing.tmf_status || '',
      options: PAYMENT_OPTIONS,
    })}${workspaceChoiceMarkup({
      name: 'customer_paid',
      label: 'Customer Payment',
      value: existing.customer_paid === true ? 'true' : '',
      options: [{ value: 'true', label: 'Customer Paid', tone: 'customer-paid' }],
    })}`;
  }
  if (actionType === 'customer_report_empty') {
    return workspaceChoiceMarkup({
      name: 'report_empty_confirmed',
      label: 'Empty Container Confirmation',
      value: '',
      options: [{ value: 'true', label: 'Confirmed', tone: 'empty-returned' }],
    });
  }
  return '';
}
